import request from '../utils/request';
/// addObjectCompany

// moderation

export function getAllFilesModeration() {
  return request({
      url: '/api/company-objects/get-emission-statuses/',
      method: 'get',
  })
}
export function addFilesModeration(data) {
  return request({
      url: '/api/company-objects/get-emission-statuses/',
      method: 'post',
      data,
  })
}
export function editFilesModeration(data) {
  return request({
      url: '/api/company-objects/get-emission-statuses/',
      method: 'put',
      data,
  })
}
